<template>
  <div class="irp-contacts-tab" data-testid="irp-contacts-tab">
    <h3 class="irp-contacts-tab__heading">Your Contacts</h3>
    <IRPFieldGrid
      v-for="(contact, index) in ownContacts"
      :key="`contact_${index}`"
      :fields="contact.fields"
    />
    <IRPPartnerFilterBar
      :key="`${individualRecordStore.sourceId}_${individualRecordStore.sourcePrimaryKey}`"
      section="contacts"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue';

import { useIndividualRecordStore } from '@/stores';
import type { RecordCollectionType } from '@/types/individual_record';

import IRPFieldGrid from './IRPFieldGrid.vue';
import IRPPartnerFilterBar from './IRPPartnerFilterBar.vue';

const individualRecordStore = useIndividualRecordStore();

const ownContacts = computed(
  () =>
    (
      individualRecordStore.contacts?.own?.contacts as
        | RecordCollectionType
        | undefined
    )?.items ?? [],
);

watch(
  () =>
    [
      individualRecordStore.sourceId,
      individualRecordStore.sourcePrimaryKey,
    ] as const,
  () => individualRecordStore.fetchSection('contacts'),
  { immediate: true },
);
</script>

<style scoped lang="pcss">
@reference "../../../css/theme.css";
.irp-contacts-tab {
  @apply flex flex-col gap-16;
}

.irp-contacts-tab__heading {
  @apply text-base font-bold text-neutral-text-strong;
}
</style>
